export default __webpack_public_path__ + "static/mural-map-9b1d9b18ba7e8117d0ce4914387f076e.jpg";